import BreadCrumb from "Components/Common/BreadCrumb";
import { adminGetAllLogVehicle } from "helpers/backend_helpers";
import { formatDate } from "helpers/globalFunction";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  Container,
  Input,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import Loader from "Components/Common/Loader";
import TableContainer from "Components/Common/TableContainer";
import DetailModalLogVehicle from "./DetailModalLogVehicle";
import DownloadModalLogVehicle from "./Downloadmodallogvehicle";

const LogVehicle = () => {
  const [tableData, setTableData] = useState<any>([]);
  const [data, setData] = useState<any>({});
  const [sort, setSort] = useState("createTime");
  const [dir, setDir] = useState(-1);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [rowCount, setRowCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [detailModal, setDetailModal] = useState<boolean>(false);
  const [downloadModal, setDownloadModal] = useState<boolean>(false);

  const [loading, setLoading] = useState<boolean>(false);
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [filterDate, setFilterDate] = useState<any>([]);
  const [filterDateOut, setFilterDateOut] = useState<any>([]);
  const [filterCategory, setFilterCategory] = useState<any>(null);
  const [filterCategoryOwner, setFilterCategoryOwner] = useState<any>(null);
  const [filterLicenseNumber, setFilterLicenseNumber] = useState<string>("");
  const [searchLicenseNumber, setSearchLicenseNumber] = useState<string>("");
  const [flatpickrKey, setFlatpickrKey] = useState(0);
  const [flatpickrKeyOut, setFlatpickrKeyOut] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchLicenseNumber(filterLicenseNumber);
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [filterLicenseNumber]);

  const getData = () => {
    setLoading(true);
    let query: any = {
      page: pagination.pageIndex,
      size: pagination.pageSize,
      sort: sort,
      dir: dir,
    };

    if (filterDate[0] && filterDate[1]) {
      query.startInDate = moment(filterDate[0]).format("YYYY-MM-DD");
      query.endInDate = moment(filterDate[1]).format("YYYY-MM-DD");
    }

    if (filterDateOut[0] && filterDateOut[1]) {
      query.startOutDate = moment(filterDateOut[0]).format("YYYY-MM-DD");
      query.endOutDate = moment(filterDateOut[1]).format("YYYY-MM-DD");
    }

    if (searchLicenseNumber) {
      query.licenseNumber = searchLicenseNumber;
    }

    if (filterCategory) {
      query.category = filterCategory.value;
    }

    if (filterCategoryOwner) {
      query.categoryOwner = filterCategoryOwner.value;
    }

    adminGetAllLogVehicle(query)
      .then((response: any) => {
        setTableData(
          response.content.map((el: any, index: any) => {
            const { inDate, outDate } = el;
            return {
              ...el,
              index: index + pagination.pageIndex * pagination.pageSize + 1,
              tanggal: formatDate(inDate, "fullDateTime") || "-",
              tanggalKeluar: formatDate(outDate, "fullDateTime") || "-",
            };
          }),
        );
        setRowCount(response.totalElements);
        setTotalPages(response.totalPages);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const comboCategory = [
    { value: "MOTOR", label: "MOTOR" },
    { value: "MOBIL", label: "MOBIL" },
    { value: "TRUK", label: "TRUK" },
  ];

  const comboCategoryOwner = [
    { value: "TAMU", label: "TAMU" },
    { value: "KARYAWAN", label: "KARYAWAN" },
    { value: "VENDOR", label: "VENDOR" },
  ];

  const columns = useMemo(
    () => [
      {
        header: "#",
        accessorKey: "index",
        enableColumnFilter: false,
        enableSorting: false,
        size: 50,
      },

      {
        header: "Tanggal Masuk",
        accessorKey: "tanggal",
        enableColumnFilter: false,
        enableSorting: false,
        size: 150,
      },

      {
        header: "Tanggal Keluar",
        accessorKey: "tanggalKeluar",
        enableColumnFilter: false,
        enableSorting: false,
        size: 150,
      },

      {
        header: "Nama Pengemudi",
        accessorKey: "driverName",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Plat Nomor",
        accessorKey: "licenseNumber",
        enableColumnFilter: false,
        enableSorting: false,
      },

      {
        header: "Kategori Kendaraan",
        accessorKey: "category",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps: any) => {
          const category = cellProps.row.original.category;
          const iconMap: any = {
            MOTOR: "ri-motorbike-line",
            MOBIL: "ri-car-line",
            TRUK: "ri-truck-line",
          };
          return (
            <div className="d-flex align-items-center gap-2">
              <i className={iconMap[category] || "ri-question-line"}></i>
              <span>{category}</span>
            </div>
          );
        },
      },

      {
        header: "Kategori Pemilik Kendaraan",
        accessorKey: "categoryOwner",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps: any) => {
          const owner = cellProps.row.original.categoryOwner;
          const iconMap: any = {
            TAMU: "ri-user-line",
            KARYAWAN: "ri-briefcase-line",
            VENDOR: "ri-store-line",
          };
          return (
            <div className="d-flex align-items-center gap-2">
              <i className={iconMap[owner] || "ri-question-line"}></i>
              <span>{owner}</span>
            </div>
          );
        },
      },

      {
        header: "Aksi",
        enableColumnFilter: false,
        enableSorting: false,
        size: 250,
        cell: (cellProps: any) => {
          return (
            <div className="hstack gap-2">
              <UncontrolledTooltip
                target={`detail-${cellProps.row.original._id}`}
              >
                Detail
              </UncontrolledTooltip>
              <button
                id={`detail-${cellProps.row.original._id}`}
                className="btn btn-sm btn-soft-info"
                onClick={() => {
                  setDetailModal(!detailModal);
                  setData(cellProps.row.original);
                }}
              >
                <i className="ri-eye-line" />
              </button>
            </div>
          );
        },
      },
    ],
    [],
  );

  const handleResetFilter = () => {
    setFilterDate([]);
    setFilterDateOut([]);
    setFilterLicenseNumber("");
    setFilterCategory(null);
    setFilterCategoryOwner(null);
    setFlatpickrKey((prev) => prev + 1);
    setFlatpickrKeyOut((prev) => prev + 1);
  };

  const handleToggleFilter = () => {
    if (showFilter) {
      handleResetFilter();
    }
    setShowFilter(!showFilter);
  };

  useEffect(() => {
    getData();
  }, [
    pagination,
    sort,
    dir,
    filterDate,
    filterDateOut,
    searchLicenseNumber,
    filterCategory,
    filterCategoryOwner,
  ]);

  document.title = "Buku Catatan Kendaraan";

  return (
    <React.Fragment>
      <DetailModalLogVehicle
        show={detailModal}
        onCloseClick={() => setDetailModal(!detailModal)}
        data={data}
      />
      <DownloadModalLogVehicle
        show={downloadModal}
        onCloseClick={() => setDownloadModal(!downloadModal)}
      />

      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Buku Catatan Kendaraan" pageTitle="Buku Catatan" />

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="border-0">
                  <div className="d-flex align-items-center">
                    <h5 className="card-title mb-0 flex-grow-1">
                      Data Kendaraan
                    </h5>
                    <div className="flex-shrink-0">
                      <div className="d-flex gap-2 flex-wrap">
                        <button
                          className="btn btn-soft-primary btn-sm"
                          onClick={handleToggleFilter}
                        >
                          <i className="ri-filter-3-line align-bottom me-1"></i>
                          Filters
                        </button>
                        <button
                          className="btn btn-soft-dark btn-sm"
                          onClick={() => setDownloadModal(!downloadModal)}
                        >
                          <i className="ri-file-download-line align-bottom me-1"></i>
                          Unduh Data
                        </button>
                      </div>
                    </div>
                  </div>
                </CardHeader>
                <CardBody className="pt-0">
                  <Collapse isOpen={showFilter}>
                    <Row className="g-3 mb-4">
                      <Col lg={3}>
                        <div>
                          <Flatpickr
                            key={flatpickrKey}
                            className="form-control"
                            options={{
                              mode: "range",
                              dateFormat: "d M Y",
                            }}
                            onChange={(e) => {
                              setFilterDate(e);
                            }}
                            value={filterDate}
                            placeholder="Pilih Tanggal Masuk"
                          />
                        </div>
                      </Col>
                      <Col lg={3}>
                        <div>
                          <Flatpickr
                            key={flatpickrKeyOut}
                            className="form-control"
                            options={{
                              mode: "range",
                              dateFormat: "d M Y",
                            }}
                            onChange={(e) => {
                              setFilterDateOut(e);
                            }}
                            value={filterDateOut}
                            placeholder="Pilih Tanggal Keluar"
                          />
                        </div>
                      </Col>
                      <Col lg={3}>
                        <div>
                          <Input
                            type="text"
                            className="form-control"
                            placeholder="Cari plat nomor..."
                            value={filterLicenseNumber}
                            onChange={(e) =>
                              setFilterLicenseNumber(e.target.value)
                            }
                          />
                        </div>
                      </Col>
                      <Col lg={3}>
                        <Select
                          value={filterCategory}
                          onChange={(e: any) => {
                            setFilterCategory(e);
                          }}
                          options={comboCategory}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          placeholder="Pilih Kategori Kendaraan"
                          isClearable
                        />
                      </Col>
                      <Col lg={3}>
                        <Select
                          value={filterCategoryOwner}
                          onChange={(e: any) => {
                            setFilterCategoryOwner(e);
                          }}
                          options={comboCategoryOwner}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          placeholder="Pilih Kategori Pemilik Kendaraan"
                          isClearable
                        />
                      </Col>
                    </Row>
                  </Collapse>

                  <div>
                    {loading ? (
                      <Loader />
                    ) : (
                      <TableContainer
                        columns={columns}
                        data={tableData || []}
                        customPageSize={10}
                        theadClass="text-muted text-uppercase"
                        manualPagination
                        pagination={pagination}
                        pageCount={totalPages}
                        onPaginationChange={setPagination}
                        divClass="table-responsive"
                      />
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default LogVehicle;
